import React, {useEffect, useState} from 'react'
import {SpotifyApiContext} from 'react-spotify-api'
import Cookies from 'js-cookie';
import SpotifyLoggedInState from "./components/authed/SpotifyLoggedInState";
import SpotifyLoggedOutState from "./components/landing/SpotifyLoggedOutState";
import { handleAuthCallback, exchangeCodeForToken } from './utils/spotifyAuth';

function App() {
    const [spotifyAuthToken, setSpotifyAuthToken] = useState()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        // Handle OAuth callback
        const callback = handleAuthCallback();
        if (callback && callback.code) {
            setIsLoading(true);
            exchangeCodeForToken(callback.code)
                .then(() => {
                    // Clear URL params
                    window.history.replaceState({}, document.title, window.location.pathname);
                    setSpotifyAuthToken(Cookies.get('spotifyAuthToken'));
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error('Failed to exchange code for token:', error);
                    setIsLoading(false);
                });
        } else if (callback && callback.error) {
            console.error('Auth error:', callback.error);
            setIsLoading(false);
        } else {
            setSpotifyAuthToken(Cookies.get('spotifyAuthToken'));
            setIsLoading(false);
        }
    }, [])

    const token = Cookies.get('spotifyAuthToken')

    if (isLoading) {
        return (
            <div className='app'>
                <div style={{textAlign: 'center', padding: '50px'}}>
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='app'>
            {
                token ?
                    <SpotifyApiContext.Provider value={token}>
                        <SpotifyLoggedInState
                            token={token}
                        />
                    </SpotifyApiContext.Provider>
                    :
                    <SpotifyLoggedOutState/>
            }
            <h5>© Matthew Kempa 2020</h5>
        </div>
    )
}

export default App;
